
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/aplikaciju-programavimas",
      function () {
        return require("private-next-pages/lt/aplikaciju-programavimas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/aplikaciju-programavimas"])
      });
    }
  